// 고객 문의 전송 (단일 출처)
// 프론트 → API Gateway(/api/contact) → Lambda → Slack Incoming Webhook.
// Slack Webhook URL은 Lambda의 서버측 env(SLACK_WEBHOOK_URL)에만 두고 프론트에는 노출하지 않는다.
//
// 엔드포인트는 REACT_APP_CONTACT_API 로 주입한다. 미설정 시 기존 API Gateway 기준으로 폴백.
const CONTACT_API =
  process.env.REACT_APP_CONTACT_API ||
  'https://1cw148rxb8.execute-api.ap-northeast-2.amazonaws.com/api/contact';

/**
 * 문의 1건을 서버 relay로 전송한다.
 * payload 예: { source, service, page, name, email, topic, category, message|content, customerId }
 * message 또는 content 중 하나로 본문을 넘기면 된다.
 * @returns {Promise<object>} 성공 시 응답 JSON (없으면 {})
 * @throws 네트워크 오류 또는 비 2xx 응답
 */
export async function sendContactInquiry(payload) {
  const res = await fetch(CONTACT_API, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      ...payload,
      timestamp: payload.timestamp || new Date().toISOString(),
    }),
  });

  if (!res.ok) {
    throw new Error(`Contact API ${res.status}`);
  }

  return res.json().catch(() => ({}));
}
